var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckBoxCircleOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0003 95.3337C28.068 95.3337 8.66699 75.9325 8.66699 52.0003C8.66699 28.068 28.068 8.66699 52.0003 8.66699C75.9325 8.66699 95.3337 28.068 95.3337 52.0003C95.3337 75.9325 75.9325 95.3337 52.0003 95.3337ZM52.0003 86.667C71.1463 86.667 86.667 71.1463 86.667 52.0003C86.667 32.8544 71.1463 17.3337 52.0003 17.3337C32.8544 17.3337 17.3337 32.8544 17.3337 52.0003C17.3337 71.1463 32.8544 86.667 52.0003 86.667ZM47.6783 69.3337L29.2936 50.9491L35.4219 44.8204L47.6783 57.0773L72.1915 32.5641L78.3197 38.6924L47.6783 69.3337Z",
    stroke: "url(#paint0_linear_5211_34057)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5211_34057",
    x1: -0.188079,
    y1: -6.4174,
    x2: 98.7289,
    y2: 39.6344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23AC49",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23AC49",
    stopOpacity: 0.1
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxCircleOutlinedIcon);
export default __webpack_public_path__ + "static/media/CheckBoxCircleOutlinedIcon.c57f706b92f5b93e3b2c040fe5670a55.svg";
export { ForwardRef as ReactComponent };